import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { AppThunkDispatch } from 'src/redux/store';
import {
  updateFilters,
  UpdateFiltersActionType,
} from '../../../../redux/products/thunks/updateFilters';
import { actions as filterMenuActions } from '../../FilterMenu/modules/slice';
import { FilterList } from '../components/FilterList';
import { onViewResultsClick } from '../modules/actions';
import {
  selectFiltersWithFilterOptionsCount,
  selectFiltersWithFilterOptionsCountWithoutSortFilter,
  selectIsUsingCollapsibleFiltersFeature,
  selectTotalSelectedFilterOptionsCount,
} from '../modules/selectors';
import { actions as filterActions } from '../modules/slice';
import { FilterListContainerDispatchProps, FilterListContainerStateProps } from '../types';

interface FilterListContainerProps {
  removeSortFilter?: boolean;
}

export const mapStateToProps = (
  state: ReduxApplicationState,
  { removeSortFilter }: FilterListContainerProps,
): FilterListContainerStateProps => ({
  error: state.products.error,
  filters: removeSortFilter
    ? // This is needed to remove the sort filter from the list when rendering the filters on large screen. Sort filter should only show on MW & TA.
      selectFiltersWithFilterOptionsCountWithoutSortFilter(state)
    : selectFiltersWithFilterOptionsCount(state),
  isLoading: state.products.isLoading,
  isUsingExpandableFilters: selectIsUsingCollapsibleFiltersFeature(state),
  totalProducts: state.products.totalProducts,
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
});

export const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
): FilterListContainerDispatchProps => ({
  onAllFiltersVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'filter impression',
      event_label: 'all filters viewed',
    });
  },
  onCloseFilters: () => dispatch(filterActions.closeModal()),
  onDeliveryFilterVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'filter impression',
      event_label: 'delivery',
    });
  },
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
  onViewResults: () => {
    batch(() => {
      dispatch(onViewResultsClick());
      dispatch(filterActions.closeModal());
    });
  },
});

export const FilterListContainer = connect(mapStateToProps, mapDispatchToProps)(FilterList);
